module.exports = __webpack_public_path__ + "img/logo3.ca03211f.svg";